import React from 'react';
const Typography: React.FC = () => {
  return <div className="mb-12" data-id="element-101">
      <style data-id="element-102">
        {`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');`}
      </style>
      <h2 className="text-xl font-semibold text-slate-800 mb-3" data-id="element-103">Typography</h2>
      <div className="bg-white rounded-lg shadow-md p-6 border border-slate-100" data-id="element-104">
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-105">
          {/* Main Font Display */}
          <div className="flex-1" data-id="element-106">
            <div className="flex items-baseline gap-3 mb-2" data-id="element-107">
              <h3 className="text-3xl font-bold text-slate-900" style={{
              fontFamily: 'Poppins, sans-serif'
            }} data-id="element-108">
                Poppins
              </h3>
              <span className="text-slate-500 bg-slate-100 px-2 py-0.5 rounded text-sm font-mono" data-id="element-109">
                Primary Font
              </span>
            </div>
          </div>

          {/* Large Aa Preview */}
          <div className="flex items-center justify-center bg-slate-50 rounded-lg p-12 min-w-[200px]" data-id="element-110">
            <span className="text-9xl text-slate-900" style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600
          }} data-id="element-111">
              Aa
            </span>
          </div>
        </div>
      </div>
    </div>;
};
export default Typography;